import React from 'react';
import {
    Card,
    Tooltip,
    Typography,
} from 'antd';
import {
    CodeOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

interface EntityLogDataPanelProps {
    entityName: string;
    entityId: string;
}

export function EntityLogDataPanel({ entityName, entityId }: EntityLogDataPanelProps) {

    const mainItems = [
        {
            label: 'Entity',
            value: entityName + ' (' + entityId + ')',
            icon: <CodeOutlined />,
        }
    ];

    return (
        <Card className="invocation-data-card" bordered={false}>
            <div className="invocation-data-grid">
                {mainItems.map((item) => (
                    <div className="invocation-data-item" key={item.label}>
                        <div className="invocation-data-item__label">
                            {item.icon}
                            <span>{item.label}</span>
                        </div>

                        <Tooltip title={item.value}>
                            <Text className="invocation-data-item__value" ellipsis>
                                {item.value}
                            </Text>
                        </Tooltip>
                    </div>
                ))}
            </div>
        </Card>
    );
}
